(function () {
  var DISMISS_DELAY = 6000;
  var dismissTimer = null;
  var lastShown = 0;

  function getEl()       { return document.getElementById('pq-cart-notify'); }
  function getBackdrop() { return document.getElementById('pq-cn-backdrop'); }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function populateAndShow(cartData) {
    var el      = getEl();
    var backdrop = getBackdrop();
    if (!el) return;

    var now = Date.now();
    if (now - lastShown < 800) return;
    lastShown = now;

    if (dismissTimer) clearTimeout(dismissTimer);

    var items = cartData && cartData.items;
    var item  = items && items[0];

    if (item) {
      var img     = el.querySelector('.pq-cn__img');
      var title   = el.querySelector('.pq-cn__title');
      var variant = el.querySelector('.pq-cn__variant');
      var price   = el.querySelector('.pq-cn__price');

      if (img) {
        var src = (item.featured_image && item.featured_image.url) || item.image || '';
        img.src = src;
        img.alt = item.product_title || item.title || '';
        img.style.display = src ? '' : 'none';
      }
      if (title)   title.textContent = item.product_title || item.title || '';
      if (variant) {
        var vt = item.variant_title;
        if (vt && vt !== 'Default Title') {
          variant.textContent = vt;
          variant.style.display = '';
        } else {
          variant.style.display = 'none';
        }
      }
      if (price) price.textContent = formatMoney(item.final_price || item.price || 0);
    }

    el.setAttribute('aria-hidden', 'false');
    el.classList.add('pq-cn--visible');
    if (backdrop) backdrop.classList.add('pq-cn--visible');

    dismissTimer = setTimeout(hideNotify, DISMISS_DELAY);
  }

  function fetchAndShow() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items && cart.items.length > 0) populateAndShow(cart);
      })
      .catch(function () {});
  }

  function hideNotify() {
    var el      = getEl();
    var backdrop = getBackdrop();
    if (el)      { el.classList.remove('pq-cn--visible'); el.setAttribute('aria-hidden', 'true'); }
    if (backdrop) backdrop.classList.remove('pq-cn--visible');
    if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
  }

  function init() {
    var el      = getEl();
    var backdrop = getBackdrop();
    if (!el) return;

    window._pqShowCartNotify = populateAndShow;

    // Theme cart:update event (quick-add, other pages)
    document.addEventListener('cart:update', function (e) {
      var detail = e.detail || {};
      if (detail.data && detail.data.didError) return;
      var cart = detail.resource;
      if (cart && cart.items && cart.items.length > 0) populateAndShow(cart);
      else fetchAndShow();
    });

    // PDP dispatches ajaxProduct:added with full cart
    document.addEventListener('ajaxProduct:added', function (e) {
      var cart = e.detail && e.detail.cart;
      if (cart && cart.items) populateAndShow(cart);
      else fetchAndShow();
    });

    // Close triggers
    var closeBtn = el.querySelector('.pq-cn__close');
    var continueBtn = el.querySelector('.pq-cn__continue');
    if (closeBtn)    closeBtn.addEventListener('click', hideNotify);
    if (continueBtn) continueBtn.addEventListener('click', hideNotify);
    if (backdrop)    backdrop.addEventListener('click', hideNotify);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideNotify();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
